import React from 'react';
import ProcessingItem from '../molecules/ProcessingImage';

const ProcessingTemplate: React.FC = () => {
  return (
    <>
      <ProcessingItem />
    </>
  );
};

export default ProcessingTemplate;
